
import { defineComponent, PropType } from 'vue'
import LetterTile from '@/components/LetterTile.vue';
import WordData from '@/types/WordData';
import YellowLetters from './YellowLetters.vue';
import { correctSpotColor, correctSpotColorBlind, notGuessedYetColor } from '@/assets/colors';
import { letterScaleAnimDuration } from '@/assets/constants';
import { ColorBlindDataKey, injectStrict } from '@/utils/Injection';

export default defineComponent({
    components: {
        LetterTile,
        YellowLetters,
    },
    props: {
        wordData: {
            required: true,
            type: Object as PropType<WordData>
        },
        rowIndex: {
            required: true,
            type: Number,
        },
        lettersScale: {
            required: true,
            type: Object as PropType<number[]>
        },
        showCorrectAnswer: {
            required: true,
            type: Boolean,
        }
    },
    setup() {
        const colorBlindData = injectStrict(ColorBlindDataKey);
        return { colorBlindData };
    },
    methods: {
        getLetter(index: number): string {
            const greenLetter = this.wordData.greenLetters[index];
            if (!this.showCorrectAnswer) return greenLetter;
            else return this.wordData.correctWord[index];
        },
        getColor(index: number): string {
            return this.wordData.greenLetters[index] == '' 
                ? notGuessedYetColor : this.correctColor;
        },
    },
    computed: {
        correctColor() {
            return this.colorBlindData.isActive
                ? correctSpotColorBlind
                : correctSpotColor;
        },
        animduration() {
            return letterScaleAnimDuration;
        }
    }
})
